import React from 'react';

interface MainProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Component for the main content area of a page.
 * Enforces the use of the semantic <main> tag.
 */
export const Main: React.FC<MainProps> = ({ children, className = '' }) => {
  // Add any common main content structural classes here if needed in the future
  const baseClasses = 'flex-grow';

  return <main className={`${baseClasses} ${className}`}>{children}</main>;
};
